<script>
  import { blurOnClick } from '../../../../../../../../../js/blurOnClick';
  import { getLoggedIn, getCartCount } from '../../../../../../../../../js/stores';
  import { filterNavItems } from '../../../../../../../../../js/navItemFilters';
  import { transitionHeight } from '../../../../../../../../../js/transitionHeight';
  import { trackLinkClick } from '../../../../../../../../../js/trackLinkClick';

  const TRANSITION_DURATION = '300ms';
  const TRANSITION_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  const loggedInStore = getLoggedIn();
  const cartCountStore = getCartCount();

  export let isOpen = false;
  export let navItems = [];

  $: filteredItems = filterNavItems({
    items: navItems,
    loggedIn: $loggedInStore,
    cartCount: $cartCountStore,
  });
</script>

<ul
  class="SubcategoryList"
  class:isOpen
  use:transitionHeight={{
    isOpen,
    duration: TRANSITION_DURATION,
    easing: TRANSITION_EASING,
  }}
>
  {#each filteredItems as item (item)}
    <li class:hidden={item.hidden}>
      <a
        class="link"
        id={item.id}
        href={item.url}
        use:blurOnClick
        use:trackLinkClick={{
          id: item.id,
          title: item.title,
          url: item.url,
        }}
      >
        <span class="title">{item.title}</span>
      </a>
    </li>
  {/each}
</ul>

<style>@charset "UTF-8";
.SubcategoryList {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
  overflow: hidden;
  position: relative;
}
.SubcategoryList > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.SubcategoryList > li::before {
  display: none;
}

.link {
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  display: block;
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
  outline: 0;
  border: 0;
  color: var(--color-text, #1a1a1a);
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: normal;
  text-align: left;
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  padding: 12px 50px 12px 50px;
}
.link::-moz-focus-inner {
  border: 0;
}
.link:focus {
  outline: none;
}
.link::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1), transform 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0);
}
.link:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
.link > * {
  position: relative;
}</style>
